import { Button, Menu, MenuTrigger, Popover } from 'react-aria-components';
import { UNSAFE_PortalProvider } from 'react-aria';
import { Avatar } from '../../atoms/avatar/avatar';
import { Typography } from '../../atoms/typography/typography';
import {
  ProfileMenuItem,
  ProfileMenuItemProps,
} from '../../atoms/profileMenuItem/profileMenuItem';
import { RefProvider } from '@maia/utils';
import { cubicBezier, motion } from 'motion/react';

type Props = {
  avatar: {
    initials: string;
    src: string;
    alt: string;
  };
  name: string;
  menuItems: Array<ProfileMenuItemProps>;
};

export function ProfileMenu(props: Props) {
  const { menuItems, avatar, name } = props;

  return (
    <RefProvider<HTMLButtonElement>>
      {({ ref, trackedElement }) => (
        <MenuTrigger>
          <Button
            aria-label="Menu"
            className="py-8 px-12 relative group"
            ref={ref}
          >
            <div className="flex items-center space-x-24">
              <div className="flex items-center space-x-16">
                <Avatar
                  initials={avatar.initials}
                  src={avatar.src}
                  alt={avatar.alt}
                  size={48}
                  variant="circular"
                />
                <Typography
                  variant="body-s"
                  weight="medium"
                  className="text-primaryMain"
                >
                  {name}
                </Typography>
              </div>

              {/* <IconAngleDown className="text-grayscale400 w-20 min-w-20 h-20 transition-transform ease-out group-data-[pressed='true']:rotate-180" /> */}
            </div>
          </Button>

          <UNSAFE_PortalProvider
            getContainer={trackedElement ? () => trackedElement : undefined}
          >
            <Popover className="w-full">
              <motion.div
                initial={{ opacity: 0, y: -15 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{
                  ease: cubicBezier(0.25, 1, 0.5, 1),
                  duration: 0.3,
                }}
              >
                <Menu className="bg-grayscale0 rounded-12 space-y-8 py-8">
                  {menuItems.map((menuItemProps, index) => (
                    <ProfileMenuItem
                      key={`profile-menu-item-${index}`}
                      {...menuItemProps}
                    />
                  ))}
                </Menu>
              </motion.div>
            </Popover>
          </UNSAFE_PortalProvider>
        </MenuTrigger>
      )}
    </RefProvider>
  );
}
